<template>
    <v-row
    class="pt-0">
        <v-col
                class="pt-0"
                cols="12"
                md="2">
            <v-text-field
                    v-model="filters.sku"
                    :label="$t('global.reference')"
            />
        </v-col>
        <v-col
                class="pt-0"
                cols="12"
                md="3">
            <v-text-field
                    v-model="filters.description"
                    :label="$t('global.description')"
            />
        </v-col>
        <template
                v-for="(field, index) in ['created_at_from', 'created_at_to']"
        >
            <v-col
                    class="pt-0"
                    cols="12"
                    md="2"
                    :key="field"
            >
                <v-menu
                        v-model="showCalendarMenu[field]"
                        :close-on-content-click="true"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        width="150px"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                                v-model="filters[field]"
                                prepend-icon="event"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                style="max-width: 290px;"
                                :label="$t('products_filters.' + field)"
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="filters[field]"
                                   @input="showCalendarMenu[field] = false"></v-date-picker>
                </v-menu>
            </v-col>
            <v-responsive
                    v-if="index % 2"
                    :key="field + '2'"
                    width="100%"
            ></v-responsive>
        </template>
    </v-row>
</template>

<script>
    import {debounce} from "../../../helpers/debounce";

    export default {
        name: 'ProductsFilters.vue',
        data() {
            return {
                showCalendarMenu: {
                    created_at_from: false,
                    created_at_to: false,
                    sold_at_from: false,
                    sold_at_to: false
                },
                filters: {
                    price: [0, 500]
                },
            }
        },
        watch: {
            filters: {
                handler: debounce(function (value) {

                    value = {
                        created_at: {
                            after: value.created_at_from,
                            before: value.created_at_to
                        },
                        description: value.description,
                        woo_commerce_product_sku: value.sku,
                    };


                    this.$emit('onFiltersChanged', value);
                }, 500),
                deep: true
            }
        }
    }
</script>

<style scoped>
</style>
